module.exports = __webpack_public_path__ + "img/back_m1.a5a5366f.png";